// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"596":"9426f86c","644":"e96d009a"}[chunkId] + ".chunk.js";
};